import { render, staticRenderFns } from "./VersionPage.vue?vue&type=template&id=01e454c1&scoped=true";
import script from "./VersionPage.vue?vue&type=script&lang=js";
export * from "./VersionPage.vue?vue&type=script&lang=js";
import style0 from "./VersionPage.vue?vue&type=style&index=0&id=01e454c1&prod&lang=less&scoped=true";

/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js";
var component = normalizer(script, render, staticRenderFns, false, null, "01e454c1", null);
export default component.exports;